// extracted by mini-css-extract-plugin
export var alertIcon = "_m2-0";